export default "/images/vendor/flag-icon-css/flags/1x1/ma.svg?3b79aff17ae55b760333c9c11e2e1998";